import React, { useMemo } from "react";
import MainDropDown from "../../../dropDown/MainDropDown";
import RadioButton from "../../../radioButton/SquareRadioButton";
import MainInput from "../../../input";

const defaultSourceOptions = [{ label: "ACU", value: 0, isDisabled: false }];
const defaultConditionOptions = [
  { label: "close", value: 0, isDisabled: false },
  { label: "open", value: 1, isDisabled: false },
  { label: "change", value: 2, isDisabled: false },
];
const defaultInputsOptions = [
  { label: "1", value: 1, isDisabled: false },
  { label: "2", value: 2, isDisabled: false },
  { label: "3", value: 3, isDisabled: false },
  { label: "4", value: 4, isDisabled: false },
];

const InputType = ({
  source,
  componentsSourceOptions = defaultSourceOptions,
  component_source,
  conditionOptions = defaultConditionOptions,
  condition,
  fieldsData,
  input,
  name,
  selectOptions,
  setSelectedPorts,
  selectedPorts,
}) => {
  const inputsOptions = useMemo(() => {
    const data = [];
    if (component_source == "0") {
      for (const property in fieldsData.inputs_info) {

        data.push({
          label: fieldsData.inputs_info[property].name,         
          value: +property,
          isDisabled: selectedPorts["input"][component_source] ? !!selectedPorts["input"][component_source][property] : false,
        });
      }
    } else {
      for (let i = 0; i <= source.inputsPortCount; i++) {
        data.push({
          label: `${i + 1}`,
          value: i + 1,
          isDisabled:selectedPorts["input"][component_source]? !!selectedPorts["input"][component_source][i + 1]: false,
        });
      }
    }
    return data.length ? data : defaultInputsOptions;
  }, [fieldsData, component_source, selectedPorts]);

  const componentSourceOptions = useMemo(() => {
    return source.inputs.length ? source.inputs : defaultSourceOptions;
  }, [source]);

  return (
    <div className="rfid-container">
      <div className="single-dropdown-container">
        <span>Components source</span>
        <MainDropDown
          placeholder="Choose an option"
          options={componentSourceOptions}
          selectedOption={component_source}
          onSelect={(option) => {
            selectOptions("component_source", option);
          }}
        />
      </div>
      <div className={"input-type-container" }>
        <div className="drop-down-section">
          <span>Condition</span>
          <MainDropDown
            options={conditionOptions}
            placeholder="Condition"
            selectedOption={condition}
            onSelect={(option) => {
              selectOptions("condition", option.value);
            }}
          />
        </div>
        <div className="drop-down-section">
          <span>Inputs</span>
          <MainDropDown
            options={inputsOptions}
            placeholder="Choose an option"
            selectedOption={input}
            onSelect={(option) => {
              setSelectedPorts((prev) => {
                let data = {
                  ...prev,
                  ["input"]: {
                    ...prev["input"],
                    [component_source]: {
                      ...prev["input"][component_source],
                      [option.value]: true,
                    }
                  },
                }
                delete data["input"][component_source][input]
                return data;
              });
              selectOptions("input", option.value);
            }}
          />
        </div>
        <div className="lock-input-section">
          <MainInput
            disabled={true}
            onChange={(e) => {
            }}
            value={name}
            label={"Name"}
          />
        </div>
      </div>
    </div>
  );
};

export default InputType;
